export default __webpack_public_path__ + "static/features_banner@2x-554ede81042e87daffe2230d5499f739.jpg";